import React from 'react';
import { InputAdornment, TextField, TextFieldProps } from '@mui/material';
import Search from '@mui/icons-material/Search';
import ComponentProps from 'store/types/ComponentProps';
import { InputProps } from 'util/form';

interface SearchInputProps
  extends ComponentProps,
    Pick<TextFieldProps, 'value' | 'onChange' | 'placeholder' | 'size' | 'select'> {
  inputProps?: InputProps;
  loading?: boolean;
  inputClassName?: string;
}

const SearchInput: React.FunctionComponent<SearchInputProps> = ({
  value,
  onChange,
  placeholder = '',
  className = '',
  inputClassName = '',
  loading = false,
  select,
  size = 'small',
  children,
}) => (
  <TextField
    disabled={loading}
    size={size}
    select={select}
    placeholder={placeholder || 'Start typing to search...'}
    value={value}
    className={className}
    onChange={onChange}
    sx={{
      '& .MuiOutlinedInput-notchedOutline legend': {
        display: 'none',
      },
      '& .MuiOutlinedInput-root': {
        borderRadius: '20px',
      },
    }}
    InputProps={{
      className: inputClassName,
      startAdornment: (
        <InputAdornment position={'start'}>
          <Search />
        </InputAdornment>
      ),
    }}
  >
    {children}
  </TextField>
);

export default SearchInput;
